import React from 'react';
import { isEqual } from 'lodash';
import LinkLibraryWithSisterScScope from 'src/constrains/LinkLibrary/LinkLibraryWithSisterScScope';

const Link = (props) => {
  const {
    onChange,
    value,
    id,
    presetLinkTypeFilter,
    linkProps,
    salesChannelContentUuid,
  } = props;
  const [link, setLink] = React.useState(value);
  React.useEffect(() => {
    if (!isEqual(value, link)) {
      setLink(value);
    }
  }, [value]);

  const onLinkChange = (l) => {
    setLink(l);
    onChange(l);
  };

  //console.log('params', params);
  return (
    <LinkLibraryWithSisterScScope
      //   error={linkTypeErrorArray
      //     .map((err) => (errCodesMap[err] ? errCodesMap[err] : err))
      //     .join('')}
      //mode={'no-modal'}
      noWrapper
      data={link || {}}
      onChange={onLinkChange}
      id={id}
      presetLinkTypeFilter={presetLinkTypeFilter}
      {...(linkProps || {})}
      salesChannelContentUuid={salesChannelContentUuid}
    />
  );
};
export default Link;
